import React, {useEffect, useRef, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import Box, {Item} from "devextreme-react/box";
import {MaterialComparisonColumnControl} from "./MaterialComparisonColumnControl";
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import {formatDate, formatNumber} from "devextreme/localization";

export function MaterialComparisonControl() {
    const data = useCountertops();
    const [collapse, setCollapse] = useState<boolean>(false);
    const boxRef = useRef<Box>(null);
    const [isPopupVisible, setPopupVisibility] = useState(false);
    const [slabUrl, setSlabUrl] = useState('');
    const [popupTitle, setPopupTitle] = useState('');

    useEffect(() => {
        boxRef.current?.instance.repaint();
    }, [data.selectedGroups.length])

    const renderContent = () => {
        return (
            <div style={{height: '100%',
                width: '100%',
                backgroundImage: 'url(' + slabUrl + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'auto',
                backgroundPosition: 'center'
            }}>
            </div>
        );
    }

    return (
        <>
            <p className={"box-header" + (collapse ? '' : ' box-header-collapsed')}>
                Explore Other Colors
                <a onClick={() => {
                    setCollapse(!collapse);
                }}>
                    <i className={(collapse ? "dx-icon-spinup" : "dx-icon-spindown") + " dx-icon-custom-style"}
                       style={{float: "right", fontSize: "32px", lineHeight: "20px"}}></i>
                </a>
            </p>
            {collapse &&
                <div>
                    {data.selectedGroups.length === 0 ?
                        <p>Add shape and material to see Available Colors</p> :
                        <Box direction={'row'} elementAttr={{class: 'split-box'}} ref={boxRef}>
                            {data.selectedGroups.map(group =>
                                <Item key={group.prodQteGrpID} ratio={1}>
                                    <p className={"group-name"}>{group.name}</p>
                                    <table className={'split-column'}>
                                        <tbody>
                                        <MaterialComparisonColumnControl group={group} showPopup={(url: string, colorName: string) => {
                                            setSlabUrl(url);
                                            setPopupTitle(group.name + ' - ' + colorName);
                                            setPopupVisibility(true);
                                        }}/>
                                        </tbody>
                                    </table>
                                </Item>
                            )}
                            {data.selectedGroups.length === 1 ? <Item ratio={1} key={'dummy'}></Item> : <></>}
                        </Box>}
                </div>}
            <Popup
                title={popupTitle}
                visible={isPopupVisible}
                hideOnOutsideClick={true}
                onHiding={() => setPopupVisibility(false)}
                showCloseButton={true}
                contentRender={renderContent}
            >
            </Popup>
        </>
    );
}
